export default __webpack_public_path__ + "assets/models/db6f81978da49c09e026218294bb1245.glb";